import React from 'react';
import Box from '@mui/material/Box';

function CardBody({ children, sx, ...rest }) {
  return (
    <Box
      sx={{
        width: '100%',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default CardBody;
